import { getAllProjects } from "./GetProjects";

/*
  Function used to update local storage to modify the changes
  
  -> Get all the available projects from local storage
  -> Filter the projects array that does not contain the current
     project (project to be modified);
  -> join the modified project with filtered project array
  -> set the project in local storage
*/
const updateLocalStorage = (projectId, projectData) => {
  const projects = getAllProjects();
  let newProjects = projects.filter((e) => e.projectId !== projectId);
  newProjects = [...newProjects, projectData];
  localStorage.setItem("db", JSON.stringify(newProjects));
};

/*
  Function used to save the project that is modified
*/
export const saveProject = (
  projectName,
  projectId,
  notStarted,
  inProgress,
  completed
) => {
  // Create a project structure
  const projectData = {
    projectId,
    projectName,
    projectBody: {
      notStarted,
      inProgress,
      completed,
    },
  };
  // Trigger the updateLocalStorage function with
  // new projectData and its Id
  updateLocalStorage(projectId, projectData);
};

export const deleteProjectById = (id) => {
  const projects = getAllProjects();
  let newProjects = projects.filter((e) => e.projectId !== id);
  localStorage.setItem("db", JSON.stringify(newProjects));
};
